import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

export const systemOverviewPlugin = createPlugin({
  id: 'system-overview',
});

/**
 * Entity content for a System's "Status" tab: an at-a-glance matrix of the
 * system's components and resources against their environments. Mounted from
 * the app's EntityPage system layout.
 */
export const EntitySystemStatusContent = systemOverviewPlugin.provide(
  createComponentExtension({
    name: 'EntitySystemStatusContent',
    component: {
      lazy: () =>
        import('./components/SystemStatusContent/SystemStatusContent').then(
          m => m.SystemStatusContent,
        ),
    },
  }),
);
